import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosPromise, AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { InvitationResponse } from 'types/organization';
import { ORGANIZATIONS_QUERY_KEY } from '@cast/infrastructure-organization';

type UseJoinOrganizationMutation = UseMutationResult<
  AxiosResponse<InvitationResponse>,
  unknown,
  string
>;

export const useJoinOrganizationMutation = (
  signal?: AbortSignal
): UseJoinOrganizationMutation => {
  const queryClient = useQueryClient();
  return useMutation({
    networkMode: 'offlineFirst',
    mutationFn: (payload) => {
      return apiClient.user.claimInvitation(
        {
          invitationId: payload,
          request: {},
        },
        { signal }
      ) as AxiosPromise<InvitationResponse>;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: [ORGANIZATIONS_QUERY_KEY],
      });
    },
    onError: (error) => notify.error(parseApiError(error)),
  });
};
